import { Form, Formik } from "formik"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useParams } from "react-router"
import Card from "../../../../shared/components/layout/Card"
import { FormContext } from "../../../../shared/contexts/FormContextProvider"
import { updatePatientAsync } from "../../state/patientEditActions"
import { IPatientEditFurtherDetailsData } from "../../state/patientEditTypes"
import SavedPatientDetailsFormCard from "../../../patient/components/formCards/SavedPatientDetailsFormCard"
import FurtherDetailsFormCard from "../../../patient/components/formCards/FurtherDetailsFormCard"
import UnsavedChangesPrompt from "../../../../shared/components/forms/UnsavedChangesPrompt"

interface Props {
  goToNextStep: () => void
  data: IPatientEditFurtherDetailsData
  setData: (data: IPatientEditFurtherDetailsData) => void
}

const ReviewAndSaveForm: React.FC<Props> = (props: Props): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation(["shared", "patient"])
  const { formikFormRef } = useContext(FormContext)
  const { patientId } = useParams<"patientId">()

  return (
    <Card className="flex-1 overflow-scroll pb-36">
      <div className="w-full">
        <h4 className="flex mb-2 font-semibold">
          { t("patient:reviewAndSave:sectionTitle") }
        </h4>
        <p className="mb-2">
          { t("patient:reviewAndSave:intro") }
        </p>

        <div className="w-full">
          <Formik
            initialValues={props.data}
            onSubmit={(_values, { setSubmitting }) => {
              const data: IPatientEditFurtherDetailsData = props.data
              dispatch(updatePatientAsync(patientId, data))
              setSubmitting(false)
            }}
            innerRef={formikFormRef}
          >
            {({submitCount}) => {
              return (
                <Form>
                  <UnsavedChangesPrompt isEnabled={submitCount < 1} />
                  <h4 className="flex mb-2 font-semibold">
                    { t("patient:details:sectionTitle") }
                  </h4>
                  <SavedPatientDetailsFormCard patientId={patientId} />

                  <h4 className="flex mb-2 font-semibold">
                    { t("patient:furtherDetails:sectionTitle") }
                  </h4>
                  <FurtherDetailsFormCard data={props.data} />
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </Card>
  )
}

export default ReviewAndSaveForm
